export class BillingCycle {
    items: BillingMetrics[];
    name: string;

    totalGb: number;

    cost: string;
    invoiceUrl: string;

    monthIndex: number;
    year: number;

    constructor() {
        this.items = [];
        this.totalGb = 0;
        this.cost = 'N/A';
        this.invoiceUrl = '';
    }

    calculateTotal() {
        for (let project of this.items) {
            this.totalGb += parseFloat(((project.bytes / 1000000) / 1000).toFixed(3));
        }
    }
}

export class BillingMetrics {
    bytes: number;
}

export class InvoiceInfo {
    amount: number;
    creationDate: string;
    invoiceForDate: string = '';
    downloadObjectUrl: string;
    sourceInvoiceNumber: string;
    userId: string;
}

export class BillingInfo {
    monthNames: string[] = [
        '',
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ];

    cycles: BillingCycle[];

    constructor(result: any) {
        this.cycles = Object.keys(result).map(date => {
            let cycle = result[date];
            let billingCycle = new BillingCycle();
            let [year, month, ...remaining] = date.split('-');

            let monthIndex = Number(month)
            billingCycle.monthIndex = monthIndex;
            billingCycle.year = Number(year);

            // get last day
            let lastDay = this.daysInMonth(monthIndex, Number(year));

            let monthName = this.monthNames[monthIndex];
            let startDate = monthName + ' 1st';
            let endDate = monthName + ' ' + String(lastDay) + this.getSuffix(lastDay);
            billingCycle.name = startDate + ' - ' + endDate + ' ' + year;

            billingCycle.items = Object.keys(cycle).map(itemKey => {
                let item = cycle[itemKey];
                let hours = item.Hours;
                let bytes = item.Bytes;

                let billingMetrics = new BillingMetrics();
                billingMetrics.bytes = Number(bytes);
                return billingMetrics;
            });

            billingCycle.calculateTotal();
            return billingCycle;
        });

    }

    private daysInMonth(month: number, year: number): number {
        return 32 - new Date(year, month - 1, 32).getDate();
    }

    private getSuffix(day: number): string {
        let suffix: string = ''
        switch (day % 10) {
            case 1:
                suffix = 'st';
                break;
            case 2:
                suffix = 'nd';
                break;
            case 3:
                suffix = 'rd';
                break;
            default:
                suffix = 'th';
        }
        return suffix;
    }

    orderDescending() {
        this.cycles.sort((firstCycle: BillingCycle, secondCycle: BillingCycle) => {
            let firstDate = new Date(firstCycle.year, firstCycle.monthIndex - 1, 1);
            let secondDate = new Date(secondCycle.year, secondCycle.monthIndex - 1, 1);
            return firstDate > secondDate ? -1 : 1;
        })
    }

    //Return current month and any past month with an invoice
    removePast2MonthsSansInvoice(){
        this.cycles = this.cycles.filter((cycle, index) => {
           if(index === 0){
               return cycle;
           }
           if(cycle.invoiceUrl){
               return cycle;
           }
           return false;

        });
    }

    updateCyclesWithCostInfo(invoices: InvoiceInfo[]) {
        for (let invoice of invoices) {
            let [year, month, ...remaining] = invoice.invoiceForDate.split('-');
            let monthIndex = Number(month);
            for (let cycle of this.cycles) {
                if (cycle.monthIndex == monthIndex && cycle.year == Number(year)) {
                    cycle.cost = new Intl.NumberFormat('en-US', {
                        style: 'currency',
                        currency: 'USD',
                        minimumFractionDigits: 2
                    }).format(invoice.amount);
                    cycle.invoiceUrl = String(invoice.downloadObjectUrl);
                }
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/billing/billing.ts